import { useEffect, useState } from 'react';
import { useNavigation } from 'react-router';

/** How long a navigation may load before the bar shows (no flash on a cached page). */
export const NAVIGATION_PROGRESS_DELAY_MS = 150;

/**
 * A thin bar along the top of the window while an in-app navigation waits
 * for its route's `clientLoader` (an entity page prefetches its data for up
 * to ENTITY_PREFETCH_TIMEOUT_MS before it commits), so a tap on a card or a
 * breadcrumb answers at once instead of seeming to do nothing.
 *
 * Framework mode only (src/routes/shell.tsx): `useNavigation` needs a data
 * router.
 */
export function NavigationProgress() {
  const loading = useNavigation().state === 'loading';
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!loading) {
      setShown(false);
      return;
    }
    const timer = window.setTimeout(() => setShown(true), NAVIGATION_PROGRESS_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [loading]);
  if (!shown) return null;
  return (
    <div
      role="progressbar"
      aria-label="Loading page"
      className="pointer-events-none fixed inset-x-0 top-0 z-[100] h-1 animate-pulse bg-primary"
    />
  );
}

export default NavigationProgress;
